var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-chevron-y transform origin-center",class:{'-scale-y-100': _vm.up}},[_c('span',{staticClass:"block border-r border-b border-current",style:({width: '0.8rem', height: '0.8rem', transform: 'rotate(45deg) translate(0, -0.2rem)', transformOrigin: 'center center'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }